// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n/* Light 模式 */\n/* Color */\n/* Animation */\n/* Other */\n.layout[data-v-31a768e4] {\n  background-color: #0c0c0c;\n  min-width: 1480px;\n}\n.layout main[data-v-31a768e4] {\n  height: calc(100% - 88px);\n}", ""]);
// Exports
module.exports = exports;
